<template>
  <div class="bars__wrapper d-flex flex-column justify-center align-center">
    <p class="list__header">
      {{ title }}
    </p>
    <div v-if="$slots.filters" class="filters-box mb-2" style="width: 100%; max-width: 520px;">
      <slot name="filters"></slot>
    </div>
    <ApexChart
      width="140%"
      height="350"
      type="bar"
      :options="data.options"
      :series="data.series"
    />
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'Edad de los alumnos'
    },
    data: {
      type: Object,
      default: () => ({
        options: {},
        series: {}
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.list {
  &__header {
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 21px;
    color: #455A64;
  }
}
.bars {
  &__wrapper {
    width: 100%;
    height: 520px;
    background: #FFF;
    box-sizing: border-box;
    border-radius: 15px;
  }
}
.filters-box {
  padding: 0 20px;
}
</style>